import { render, staticRenderFns } from "./ConnectionRequestModal.vue?vue&type=template&id=527edee8&scoped=true&"
import script from "./ConnectionRequestModal.vue?vue&type=script&lang=js&"
export * from "./ConnectionRequestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527edee8",
  null
  
)

export default component.exports